import { create } from "zustand"

import type { PurchasingCostListEntry } from "@/graphql/codegen/graphql"

interface OpenFormDialogPayload {
  warehouseAreaId: string | null
  editingCost: PurchasingCostListEntry | null
  isFuture: boolean
}

interface PurchaseCostDialogStore {
  isFormDialogOpen: boolean
  formDialog: OpenFormDialogPayload | null
  historyWarehouseAreaId: string | null
  openFormDialog: (payload: OpenFormDialogPayload) => void
  closeFormDialog: () => void
  openHistoryDialog: (warehouseAreaId: string) => void
  closeHistoryDialog: () => void
}

export const usePurchaseCostDialogStore = create<PurchaseCostDialogStore>((set) => ({
  isFormDialogOpen: false,
  formDialog: null,
  historyWarehouseAreaId: null,

  openFormDialog: (payload) => set({ isFormDialogOpen: true, formDialog: payload }),

  closeFormDialog: () => set({ isFormDialogOpen: false, formDialog: null }),

  openHistoryDialog: (warehouseAreaId) => set({ historyWarehouseAreaId: warehouseAreaId }),

  closeHistoryDialog: () => set({ historyWarehouseAreaId: null }),
}))
